// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".modal-WUuxi {\n  overflow: visible;\n  z-index: 1005;\n  outline: 0;\n  position: fixed;\n  top: 0;\n  left: 0;\n}\n.dialogContent-r\\+Y2- {\n  height: 100%;\n  margin: 0;\n}\n.dialogContent-r\\+Y2- .main-7SW\\+3 {\n  max-height: none;\n}\n.resizable-SLBco {\n  border: 3px solid transparent;\n}\n.hidden-5QYWq {\n  position: absolute !important;\n  top: -5000px;\n  left: -5000px;\n  visibility: hidden;\n  opacity: 0;\n}\n.noScroll-ps4ga {\n  overflow: hidden;\n}\n", "",{"version":3,"sources":["webpack://./app/EAssessment.UI.Common/app-components/dialogs/resizable-dialog/index.less"],"names":[],"mappings":"AAGA;EAEI,iBAAA;EAEA,aAAA;EAEA,UAAA;EAEA,eAAA;EACA,MAAA;EACA,OAAA;AA8GJ;AAxHA;EAcI,YAAA;EACA,SAAA;AA6GJ;AA5HA;EAkBM,gBAAA;AA6GN;AA/HA;EAuBI,6BAAA;AA2GJ;AAlIA;EA2BI,6BAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AA0GJ;AAzIA;EAmCI,gBAAA;AAyGJ","sourcesContent":["@import '@cirrus/legacy/app-components/app/styles/font-size-variables.less';\n@import '../dialog/variables';\n\n:local {\n  .modal {\n    overflow: visible;\n\n    z-index: @dialog-z-index;\n\n    outline: 0;\n\n    position: fixed;\n    top: 0;\n    left: 0;\n  }\n\n  .dialogContent {\n    height: 100%;\n    margin: 0;\n\n    .main {\n      max-height: none;\n    }\n  }\n\n  .resizable {\n    border: 3px solid transparent;\n  }\n\n  .hidden {\n    position: absolute !important;\n    top: -5000px;\n    left: -5000px;\n    visibility: hidden;\n    opacity: 0;\n  }\n\n  .noScroll {\n    overflow: hidden;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pageTitleFontSize": "22px",
	"pageTitleLineHeight": "55px",
	"white": "#fff",
	"black": "#000",
	"yellow": "#008859",
	"yellowinprogress": "#BEA66E",
	"blackt30": "rgba(0, 0, 0, 0.3)",
	"black50": "rgba(0, 0, 0, 0.75)",
	"blue100": "#4690d1",
	"blue120": "#2791c6",
	"blue130": "#2196f3",
	"blue150": "#add2f7",
	"blue210": "#287ec7",
	"blue300": "#0478c6",
	"blue400": "#024b7b",
	"blue330": "#0055b0",
	"brown310": "#7f707d",
	"red": "red",
	"red70": "#f7bfb9",
	"red100": "#e87d7d",
	"red300": "#f35958",
	"red320": "#e05251",
	"red405": "#a94442",
	"red410": "#bc2b43",
	"red500": "#cc2d30",
	"red550": "#c60000",
	"red900": "#ff0000",
	"red905": "#cf4444",
	"red910": "#c60000",
	"green200": "#d8f0ea",
	"green210": "#c0e8dc",
	"green250": "#09998d",
	"green270": "#47bcb3",
	"green300": "#008859",
	"green310": "#4cb992",
	"green505": "#119264",
	"green520": "#00794f",
	"green650": "#b1dac6",
	"green700": "#008000",
	"green710": "#30b382",
	"green800": "#008859",
	"yellow90": "#fbdba0",
	"yellow410": "#fedb97",
	"orange200": "#eda04f",
	"orange300": "#ee9a02",
	"orange350": "#e7a257",
	"orange360": "#c3a565",
	"orange380": "#ff8c40",
	"orange400": "#ef7400",
	"orange420": "#ff6600",
	"orange550": "#bf5000",
	"blue170": "#7e9fc2",
	"blue220": "#537fad",
	"blue250": "#2879c7",
	"darkBlue400": "#272c40",
	"blue305": "#0055b0",
	"blue310": "#00829b",
	"brown320": "#7f707d",
	"gray75": "#f6f6f6",
	"gray80": "#eeeeee",
	"gray85": "#ecedec",
	"gray95": "#d9d9d9",
	"gray120": "#e5e9ec",
	"gray200": "#dddddd",
	"gray201": "#f2f2f2",
	"gray214": "#c4c4c4",
	"gray215": "#cccccc",
	"gray220": "#ccd0d3",
	"gray225": "#c1c9cd",
	"gray240": "#cfcfcf",
	"gray230": "#d9edf7",
	"gray245": "#8b8b8b",
	"gray250": "#808080",
	"gray320": "#dedce0",
	"gray400": "#5e5e5e",
	"gray420": "#555555",
	"gray850": "#554854",
	"gray305": "#757575",
	"gray500": "#333333",
	"gray800": "#4a4a4a",
	"gray820": "#40465d",
	"gray855": "#8b91a0",
	"gray280": "#999999",
	"gray50": "#f9f9f9",
	"gray100": "#ececec",
	"gray125": "#e4e4e4",
	"gray235": "#c1bebe",
	"gray350": "#6b546a",
	"gray600": "#f1f1f1",
	"gray720": "#b6b6b6",
	"gray740": "#b6a8b4",
	"gray755": "#ebebeb",
	"gray810": "#525252",
	"gray860": "#9b9b9b",
	"gray870": "#929292",
	"gray890": "#756372",
	"gray895": "#989898",
	"gray910": "#444059",
	"gray925": "#9c9c9c",
	"gray930": "#ddcfac",
	"gray935": "#5f6368",
	"gray920": "#757575",
	"gray950": "#ece4d0",
	"gray1000": "#ebe8e8",
	"gray1010": "#e6e6e6",
	"gray1050": "#e0e6f0",
	"gray1060": "#c6c6c6",
	"gray1100": "#ededed",
	"gray1120": "#8e818c",
	"gray1150": "#212121",
	"purple": "#6a546a",
	"transparent": "transparent",
	"modal": "modal-WUuxi",
	"dialogContent": "dialogContent-r+Y2-",
	"main": "main-7SW+3",
	"resizable": "resizable-SLBco",
	"hidden": "hidden-5QYWq",
	"noScroll": "noScroll-ps4ga"
};
export default ___CSS_LOADER_EXPORT___;
